module.exports = __webpack_public_path__ + "static/img/1.3b6035c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/TechnicalSupport/equipment/Turning/1.png
// module id = k6LY
// module chunks = 13